namespace('compass.account');

compass.account.ChangePasswordWidget = compass.defineWidget(function ChangePasswordWidget(options) {
	var me = this;
	var _settings = options;
	var d = jQuery.dom.getContext(me);
	
	var _form;
	var _oldPasswordInput;
	var _passwordWidget;
	
	var _labels = {
		cPassword: "Change Password",
		oPassword: "Old Password",
		nPassword: "Create Password",
		nPassword2: "Confirm Password"
	};

	me.getValues = function () {
		var _passwordWidgetValues = _passwordWidget.grabValues();
		var _oldPasswordValue = _oldPasswordInput.val();
		return {
			'oldPassword': _oldPasswordValue,
			'newPassword': _passwordWidgetValues.password1
		};
	};
	
	_drawOldPassword = function() {
		_oldPasswordInput = d.input({
			name: 'oldPassword',
			type: 'password',
			className: 'oldPassword oldPasswordInput',
			'tabindex': '0',
			placeholder : _labels.oPassword,
			'data-parsley-required': 'true',
			'data-parsley-trigger': 'change'
		});
		
		return d.fieldLabelPair({
			className : 'oldPassword',
			label : _labels.oPassword
		}, [
			_oldPasswordInput
		]);
	};

	me.render = function (widgetElem) {
		var _passwordWidgetDiv = d.div();
		_passwordWidget = new compass.demographic.PasswordWidget(_passwordWidgetDiv, {
			WUID : 'passwordWidget_changePassword',
			placeholder1 : _labels.nPassword,
			placeholder2 : _labels.nPassword2
		});
		
		var _oldPasswordFieldPair = _drawOldPassword();
		
		_form = d.form({
			className: 'changePasswordForm'
		},
			_oldPasswordFieldPair,
			_passwordWidgetDiv,
			d.button({
				className: 'button'
			}, 'Update')
		);

		_form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);
				
				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});
				
				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});
		
		_form.on('submit', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			me.trigger(CompassEvents.ChangePassword, me.getValues());
		});

		widgetElem.append(
			d.h2({className: "headerTitle"}, _labels.cPassword),
			_form
		);
	};
}, {
	WUID: "crap",
	widgetName: 'ChangePasswordWidget'
});
